import { css, Theme } from '@mui/material';
import { SerializedStyles } from '@emotion/react';

export const themeMediaQuery =
  (
    theme: Theme,
    key: keyof Theme['breakpoints']['values'],
    useContainerQuery: boolean = false,
  ) =>
  (
    styles: TemplateStringsArray,
    ...args: (string | number | SerializedStyles)[]
  ) => css`
    ${useContainerQuery
      ? `@container (min-width: ${theme.breakpoints.values[key]}px)`
      : theme.breakpoints.up(key)} {
      ${css(styles, ...args)}
    }
  `;
